<template>
  
    <div class="  px-container" style="background-color: #7e83e0;color: #fff;">
      <div class="c-text-between c-text-both" style="padding: 8px;">
        <div>我们正在从 github.com/frankaemika 迁移至 github.com/frankarobotics</div>
        <a style="border: 2px solid #fff;padding: 4px 20px;cursor: pointer;border-radius: 5px;" class="newBack" target="_blank" rel="noopener "  href="https://www.franka-community.de/t/important-github-is-moving-june-15-welcome-to-frankarobotics/8128">了解更多</a> 
      </div> 
    </div>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10" style="text-align: left;">探索·加入·共创</span>
        <h1>Franka社区杰出成果展</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
           Franka社区以机器人技术与人工智能领域的创新协作精神著称。这里汇聚了推动行业发展的标杆级成果，展现社区的非凡创造力！
        </span> 
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          想让您的成果获得展示？如果您有值得分享的Franka社区贡献，欢迎发送至china@franka.de。我们期待为您点亮创新之光！
        </span> 
      </div> 
  
      <div class="display-width">
        <img src="@/assets/images/resources/_Frank Robotics0615_resized-1 (1).jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    
    <div id="resources-productdocumentation"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">社区资源</span>
      <hr class="divider">
    </div>  
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">机器人控制与运动规划</h3>
      <div class="c-mb-20">专为Franka机器人打造的工具框架，聚焦实时控制库开发、运动规划及轨迹生成技术。</div> 
      <div>- <strong>SpaceMouse 遥操作*Franka官方支持*</strong>
        <a href="" class="linkTag">&nbsp;<router-link to="/develop#spacemouse-anchor">[官方演示与集成方案]</router-link>&nbsp; </a> | 基于 ROS 2 的集成方案，通过 3Dconnexion SpaceMouse 实现 Franka FR3 的实时笛卡尔速度控制。包含夹爪控制、多机械臂支持及开发容器配置，专为遥操作、触觉控制及教学演示场景优化。
      </div>
      <div>- <strong>GELLO 遥操作*Franka官方支持*</strong>
        <a href="/#/develop#spacemouse-anchor" target="_blank" class="linkTag">&nbsp;[官方演示与集成方案]&nbsp; </a> | 基于 ROS 2 的 Franka FR3 实时控制框架，通过 GELLO 遥操作平台实现低延迟关节阻抗控制，支持 Franka Hand 与 Robotiq 夹爪的协同操作。内置开发容器实现快速部署，适用于人机交互（HRI）、快速原型开发及教育应用。
（注：
      </div>  
      <div>- <strong>Deoxys </strong><a href="https://zhuyifengzju.github.io/deoxys_docs/html/getting_started/overview.html" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|为Franka机器人提供的Python接口与实时C++控制器，适合机器人学习与视觉运动任务。
      </div> 
      <div>- <strong>Frankx </strong><a href="https://github.com/pantor/frankx" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|支持实时轨迹生成的高级C++/Python运动库。
      </div> 
      <div>- <strong>Franky </strong><a href="https://github.com/TimSchneider42/franky" class="linkTag" target="_self">&nbsp;[链接1]&nbsp;</a><a href="https://pypi.org/project/franky-panda/" class="linkTag" target="_self">&nbsp;[链接2]&nbsp;</a>|通过直观的C++/Python接口简化实时运动生成。
      </div> 
      <div>- <strong>Polymetis </strong><a href="https://facebookresearch.github.io/fairo/polymetis/overview.html" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|面向基于学习的操作任务的高级机器人控制框架。
      </div> 
      <div>- <strong>Franka ROS Interface</strong><a href="https://github.com/justagist/franka_ros_interface" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>| 可定制的ROS控制器，实现真实与仿真机器人的无缝切换。
      </div> 
      <div>- <strong>Galaxy Franka Driver</strong><a href="https://github.com/eugenegalaxy/Franka-Galaxy" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|支持本地和远程控制的C++驱动与Python Web API。
      </div> 
      <div>- <strong>Panda-py</strong><a href="https://github.com/JeanElsner/panda-py" class="linkTag" target="_self">&nbsp;[链接1]&nbsp;</a><a href="https://arxiv.org/pdf/2307.07633" class="linkTag" target="_self">&nbsp;[链接2]&nbsp;</a>|提供Franka机器人实时控制的Python绑定库。
      </div> 
      <div>- <strong>Franka R</strong><a href="https://github.com/dti-research/frankr" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|基于ROS的API，专注于定制化碰撞处理。
      </div> 
      <div>- <strong>Ruckig </strong><a href="https://github.com/pantor/ruckig/" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|基于传感器输入的实时轨迹优化库。
      </div> 
      <div>- <strong>FrankaEmika Panda机器人抓放教程</strong><a href="https://de.mathworks.com/help/robotics/ug/pick-and-place-using-rrt-for-manipulators.html" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|使用RRT算法实现抓放任务的路径规划。
      </div> 
      <div>- <strong>基于RRT的机械臂抓放指南</strong><a href="https://www.youtube.com/watch?app=desktop&v=9GeyCgNqoDw" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|使用MoveIt完成抓放任务的逐步教程。
      </div> 
      <div>- <strong>The Robotics Toolbox for Python</strong><a href="https://github.com/petercorke/robotics-toolbox-python" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|提供机器人建模、仿真与控制工具，涵盖运动学、路径规划与定位。
      </div>  
    </div> 
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">机器人仿真与环境工具</h3>
      <div class="c-mb-20">专为Franka机器人打造的虚拟环境仿真测试工具集，支持实时交互、强化学习及多模态仿真能力。</div>
      
      <div>- <strong>Panda Simulator</strong><a href="https://github.com/justagist/panda_simulator" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        | 基于Gazebo的FrankaEmika Panda仿真器，提供完整的ROS接口支持，可实现高保真状态反馈。
      </div> 
      <div>- <strong>Franka Emika Panda 7自由度机器人PyBullet仿真</strong><a href="https://github.com/PaulPauls/franka_emika_panda_pybullet" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        | 基于物理引擎的FrankaPanda运动学仿真，支持逆向动力学与重力补偿计算。
      </div>
      <div>- <strong>Panda Gym</strong><a href="https://github.com/qgallouedec/panda-gym" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        基于PyBullet物理引擎与Gymnasium的机器人训练环境集合。
      </div>
      <div>- <strong>Franka机器人强化学习环境教程</strong><a href="https://docs.robotflow.ai/pyrfuniverse/tutorials/franka_robotics.html" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        使用Franka机器人搭建自定义强化学习环境的完整指南。
      </div>
      <div>- <strong>Franka Kitchen</strong><a href="https://robotics.farama.org/envs/franka_kitchen/franka_kitchen/" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        | 基于强化学习与模仿学习的厨房任务仿真环境，专为Franka机器人设计。
      </div>
      <div>- <strong>Rocksi </strong><a href="https://rocksi.net/" class="linkTag" target="_self">&nbsp;[链接1]&nbsp;</a>
        <a href="https://github.com/ndahn/Rocksi" class="linkTag" target="_self">&nbsp;[链接2]&nbsp;</a> 
        基于Blockly编程的网页仿真器，适合初学者通过Franka机器人学习机器人学基础概念。
      </div>
      <div>- <strong>Franka机器人Isaac Sim仿真教程 </strong><a href="" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        使用英伟达Isaac Sim环境仿真与控制Franka机器人的实践教程。
      </div>
      <div>- <strong>Nvidia Isaac SIM/Lab</strong>
        <a href="https://docs.omniverse.nvidia.com/isaacsim/latest/cortex_tutorials/tutorial_cortex_4_franka_block_stacking.html" class="linkTag" target="_self">&nbsp;[链接1]&nbsp;</a> 
        <a href="https://docs.omniverse.nvidia.com/isaacsim/latest/core_api_tutorials/tutorial_core_adding_manipulator.html" class="linkTag" target="_self">&nbsp;[链接2]&nbsp;</a> 
        在Isaac Sim中仿真与控制Franka机器人的分步指南，提供实时机器人仿真的关键技术解析。
      </div>
      <div>- <strong>Isaac ROS中通过MoveIt控制Franka机器人</strong><a href="https://medium.com/@kabilankb2003/moveit-control-franka-robot-in-isaac-ros-0467a7dfe2d7" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        博客教程，演示如何通过MoveIt在英伟达Isaac Omniverse仿真平台实现Franka机械臂的同步控制与仿真。
      </div>
      <!-- <div>- <strong>教程</strong><a href="" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
         关于 Pilot 的教程，Pilot 是用于与 Franka Hand 和 Desk 用户界面交互的控制器。
      </div> -->
    </div> 
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">学习环境与数据集</h3>
      <div class="c-mb-20">为机器人训练提供支持的资源库，包含强化学习环境及面向机器人操作任务的大规模数据集。</div>
      <div>- <strong>RLBench</strong><a href="https://github.com/stepjam/RLBench" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        视觉引导操作研究的综合性基准测试平台，支持强化学习、模仿学习等多种训练范式。
      </div>
      <div>- <strong>DROID </strong><a href="https://droid-dataset.github.io/" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        包含超过76,000次机器人操作演示的多样化数据集，助力提升机器人学习策略。
      </div>
      <div>- <strong>Open X-Embodiment</strong><a href="https://robotics-transformer-x.github.io/" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        跨平台通用机器人操作策略开发所需的大规模数据集与预训练模型集。
      </div>
    </div>  
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">标定与控制方法</h3>
      <div class="c-mb-20">通过精密标定与先进控制技术提升Franka机器人精度与功能的工具及方法论</div>
      <div>- <strong>机器人运动学标定</strong><a href="https://github.com/platonics-delft/kinematics_calibration" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        提供Franka机器人运动学标定方法，确保高精度定位。
      </div>
      <div>- <strong>人性化阻抗控制器Python接口  </strong><a href="https://download.franka.de/CADModels.zip" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        基于ROS的阻抗控制Python类库，用于Franka机器人控制。
      </div>
    </div>  <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">其他资源</h3>
      <div class="c-mb-20">本类别包含适用于不同弗兰卡机器人应用场景的多样化资源，如3D模型与硬件配件。</div>
      <div>- <strong>3D相机支架</strong><a href="https://download.franka.de/panda_camera_mount.zip" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        可直接打印的3D模型，用于将Intel RealSense或通用1/4英寸接口相机安装至弗兰卡机器人。
      </div>
      <div>- <strong>SOLIDWORKS®模型</strong><a href="https://download.franka.de/CADModels.zip" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        包含机械臂、夹爪及控制器的全可动3D模型，可在您的工作环境中进行机器人运动仿真、工作半径测试及外设集成可视化。
      </div>
    </div> 
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">来自Franka社区的精彩成果</span>
      <hr class="divider">
    </div> 
    
  <div class="px-container stress-content">
    <div v-for="(item, index) in contentList" :key="item.name + index" style="min-height: 180px; ">
      <div style="aspect-ratio: 270/200;">
          <div  style="width: 100%;" class="c-text-both" v-show="!item.iframeValue"> 
            <img :src="item.url" style="width: 100%;aspect-ratio: 270/200;" />
            <div class="playButton "  @click="item.iframeValue = true">  
            </div>
          </div>
          <iframe
              :src="item.videoUrl" v-if="item.iframeValue"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              allowfullscreen="true"
            ></iframe> 
        </div> 
      <div class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
        {{ item.name }}
      </div>
      <div class="c-text-left c-width-precent-100">
        {{ item.value }}
      </div>
    </div>
  </div>
    <div id="resources-community"></div> 
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">社区论坛</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap"> 
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;"> 
        <h1>欢迎来到 Franka 社区论坛</h1>
        <span class="c-mt-10 ">在这里和来自全球的Franka机械臂使用者互动</span>
        <span class="c-mt-10 c-mb-5 c-text-left text-indent">
          社区论坛提供了一个互动平台，专门为我们的机器人和产品服务。在这里，用户可以参与讨论、分享见解，并与其他也在使用 Franks Robotics 技术的同行建立联系。该论坛是一个宝贵的资源，帮助您探索具体应用、解决问题，并保持对我们机器人系统最新发展和创新的了解。
        </span> 
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
        </div>
      </div>   
      <div class="display-width">
        <img src="@/assets/images/resources/image 55-2.png" alt=""
          style="    height: auto; max-width: 100%;">
      </div> 
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">开发</span>
      <hr class="divider">
    </div> 
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10" style="text-align: left;">建设，创造，革新</span>
        <h1>在Franka机器人平台上开发</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          开发人员使用Franka Research 3机器人平台的资源中心。深入了解旨在加速您的开发旅程的大量工具、库和文档。
          无论你是一名经验丰富的开发者还是刚刚起步，你都能找到构建、创造和创新所需的一切。
        </span> 
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <div class="buttonSite" style="width: 100px;">
            <a href="/#/develop" target="_self">探索</a>
          </div>
        </div>
      </div>  
      
      <div class="display-width">
        <img src="@/assets/images/resources/_Franka Robotics _Franka AI Companion_20241723.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
 

  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {
      contentList: [
        // {
        //   name: 'Meta',
        //   value: '推动机器人技术和触觉感知!',
        //   url: require('@/assets/images/main/hqdefault.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1hk9BYTEuw'
        // },
        {
          name: '丰田研究院',
          value: '机器人动作学习',
          url: require('@/assets/images/main/hqdefault (1).jpg'),
          iframeValue:false,
          videoUrl:'https://player.bilibili.com/player.html?bvid=BV1Y696YjEkT'
        },
        // {
        //   name: '麻省理工学院',
        //   value: '机器人轨迹规划研究',
        //   url: require('@/assets/images/main/hqdefault (2).jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1GC96Y5E23'
        // },
        // {
        //   name: '清华大学',
        //   value: '从无法抓取的姿势中学习物体的预抓取操作',
        //   url: require('@/assets/images/main/hqdefault (3).jpg')
        // },
        // {
        //   name: 'DROID',
        //   value: '大规模野外机器人操作数据集',
        //   url: require('@/assets/images/main/hqdefault (4).jpg')
        // },
        // {
        //   name: '昆士兰科技大学',
        //   value: '动态环境中移动操作的反应式基础控制',
        //   url: require('@/assets/images/main/hqdefault (5).jpg')
        // },
        {
          name: '多伦多大学',
          value: '机器人助力自动化化学实验',
          url: require('@/assets/images/main/hqdefault (6).jpg'),
          iframeValue:false,
          videoUrl:'https://player.bilibili.com/player.html?bvid=BV1GC96Y5Ed3'
        },
        {
          name: '德累斯顿工业大学',
          value: 'Franka机器人辅助手术 - 手术室人机交互',
          url: require('@/assets/images/main/hqdefault (7).jpg'),
          iframeValue:false,
          videoUrl:'https://player.bilibili.com/player.html?bvid=BV1t396YKE99'
        },
        // {
        //   name: '斯坦福大学',
        //   value: 'Franka Robotics为李飞飞团队的研究开发提供平台！',
        //   url: require('@/assets/images/main/1741311387142.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1ZbHse1E48'
        // },
        // {
        //   name: '麻省理工大学',
        //   value: 'Franka Robotics携手麻省理工女博士为家用机器人的开发做出重要贡献，让人们远离家务的烦恼！',
        //   url: require('@/assets/images/main/1741311514704.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1pbw8epEDy'
        // },
        // {
        //   name: '卡耐基梅隆大学',
        //   value: 'Franka Research 3在卡内基梅隆大学发表的ManipGen框架的研究中起到了关键作用！',
        //   url: require('@/assets/images/main/1741311693730.jpg'),
        //   iframeValue:false,
        //   videoUrl:'https://player.bilibili.com/player.html?bvid=BV1Q5kMY9Ev5'
        // },
      ]
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1199px) {
  .stress-content>div {
    width: calc(33.33% - 20px);
    /* 3 个项目 */
  }
}
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
    .stress-content>div {
    width: calc(50% - 20px);
    /* 2 个项目 */
  }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
    .stress-content>div {
    width: 100%;
    /* 1 个项目 */
  }

  }
  /* 默认情况下，一行展示 4 个项目 */
.stress-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  /* 项目之间的间隔 */
}
.stress-content>div {
  width: calc(25% - 20px);
  /* 4 个项目 */
}
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
  